unit UZrValueList;

interface

uses
  System.Contnrs, UZrValueModel, UEssentialHelper;

type
  TZrValueList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    function GetItem(i: Integer): TZrValueModel;
    procedure PropertyChanged;
    procedure SetValues(json: string);
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    function ToString: string; override;
    procedure Add(item: TZrValueModel);
    procedure GetAll(url: string; personalNr: string; datum: TDateTime);
    property Items[i: Integer]: TZrValueModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged write SetOnPropertyChanged;
  end;

implementation

uses
  WebLib.JSON, System.SysUtils, WebLib.REST, Js, System.Classes;

{ TZrValueList }

procedure TZrValueList.Add(item: TZrValueModel);
begin
  inherited Add(item);
end;

procedure TZrValueList.GetAll(url, personalNr: string; datum: TDateTime);
var obj: TJsonObject;
    helper: string;
    client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  var jso: TJsObject;
  begin
    jso:=TJsJson.parseObject(aResponse);
    if jso['value']<>nil then
      Self.SetValues(string(jso['value']));
    Self.PropertyChanged;
  end;
begin
  obj:=TJsonObject.Create;
  obj.AddPair('PersonalNr',personalNr);
  obj.AddPair('Datum',DateTimeToStr(datum));
  helper:=obj.ToString;
  obj:=TJsonObject.Create;
  obj.AddPair('value',helper);
  client:=TRestClient.Create(nil);
  client.OnResponse:=Response;
  client.HttpsPost(url+'/ZrValueService/GetAll','application/json',obj.ToString);
  client.Free;
  obj.Free;
end;

function TZrValueList.GetItem(i: Integer): TZrValueModel;
begin
  Result:=inherited GetItem(i) as TZrValueModel;
end;

procedure TZrValueList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TZrValueList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TZrValueList.SetValues(json: string);
var obj: TJsObject;
    i, count: Integer;
begin
  Self.Clear;
  obj:=TJsJson.parseObject(json);
  if obj['Count']<>nil then begin
    count:=StrToInt(string(obj['Count']));
    for i:=0 to count-1 do begin
      if obj['Item'+IntToStr(i)]<>nil then
        Self.Add(TZrValueModel.Create(string(obj['Item'+IntToStr(i)])));
    end;
  end;
end;

function TZrValueList.ToString: string;
var i: Integer;
    lst: TStringList;
begin
  lst:=TStringList.Create;
  lst.Add('  Count: '+IntToStr(Self.Count));
  for i:=0 to Self.Count-1 do
    lst.Add(Self.Items[i].ToString);
  Result:=lst.Text;
  lst.Free;
end;

end.
